module.exports = __webpack_public_path__ + "static/phone2-a4094527ba9ef372fb8431658cc84919.png";